import { useState } from "react";
import { useMount } from "react-use";
import { Testimonial } from "@scrile/api-provider/dist/api/TestimonialsProvider";
import providers from "../../../../lib/providers";

export default function useViewController() {
  const [loading, setLoading] = useState(false);
  const [testimonial, setTestimonial] = useState<Testimonial | null>(null);

  useMount(() => {
    (async function () {
      setLoading(true);
      try {
        const testimonials = await providers.TestimonialsProvider.findAll();
        setTestimonial(testimonials[0] || null);
      } finally {
        setLoading(false);
      }
    })();
  });

  return { loading, testimonial };
}
